export const GETALL_CUSTOMER_REQUEST = "GETALL_CUSTOMER_REQUEST";
export const GETALL_CUSTOMER_SUCCESS = "GETALL_CUSTOMER_SUCCESS";
export const GETALL_CUSTOMER_FAIL = "GETALL_CUSTOMER_FAIL";

export const GETBYID_CUSTOMER_REQUEST = "GETBYID_CUSTOMER_REQUEST";
export const GETBYID_CUSTOMER_SUCCESS = "GETBYID_CUSTOMER_SUCCESS";
export const GETBYID_CUSTOMER_FAIL = "GETBYID_CUSTOMER_FAIL";
 
export const ADD_CUSTOMER_REQUEST = 'ADD_CUSTOMER_REQUEST';
export const ADD_CUSTOMER_SUCCESS = 'ADD_CUSTOMER_SUCCESS';
export const ADD_CUSTOMER_FAIL = 'ADD_CUSTOMER_FAIL';
 
export const UPDATE_CUSTOMER_REQUEST = 'UPDATE_CUSTOMER_REQUEST';
export const UPDATE_CUSTOMER_SUCCESS = 'UPDATE_CUSTOMER_SUCCESS';
export const UPDATE_CUSTOMER_FAIL = 'UPDATE_CUSTOMER_FAIL';
 
export const DELETE_CUSTOMER_REQUEST = 'DELETE_CUSTOMER_REQUEST';
export const DELETE_CUSTOMER_SUCCESS = 'DELETE_CUSTOMER_SUCCESS';
export const DELETE_CUSTOMER_FAIL = 'DELETE_CUSTOMER_FAIL';
 